import { CONFIG_DOCS, COLLECTIONS, resolveSettings, type SettingsDoc, type SystemSettings } from '@crew/shared';
import { doc, onSnapshot } from 'firebase/firestore';
import { useEffect, useState } from 'react';
import { demoStore } from '@/demo/demoStore';
import { IS_DEMO } from '@/demo/demoMode';
import type { Ts } from '@/lib/ts';
import { getFirebase } from '@/services/firebase';

/**
 * הגדרות המערכת (חתימת וואטסאפ, מקסימום עובדים...). מנהלים קוראים חי מ-Firestore;
 * אם אין מסמך או שהקריאה נכשלה — ברירות המחדל, כך שהמסכים תמיד עובדים.
 */
export function useSystemSettings(): SystemSettings {
  const [settings, setSettings] = useState<SystemSettings>(() => resolveSettings(IS_DEMO ? demoStore.settingsRaw() : null));
  useEffect(() => {
    if (IS_DEMO) {
      const push = () => setSettings(resolveSettings(demoStore.settingsRaw()));
      push();
      return demoStore.subscribe(push);
    }
    const { db } = getFirebase();
    return onSnapshot(
      doc(db, COLLECTIONS.config, CONFIG_DOCS.settings),
      (s) => setSettings(resolveSettings(s.exists() ? (s.data() as SettingsDoc<Ts>) : null)),
      () => setSettings(resolveSettings(null)),
    );
  }, []);
  return settings;
}
